"use client";

import { LazyImage, RTERenderer } from "@piperunner-cms/components";
import type { GetBlogListResponse } from "@piperunner-cms/types/v1";
import { Card, CardContent, CardHeader } from "@repo/ui/components/base/card";
import Link from "next/link";
import { Masonry } from "react-plock";
import styles from "@/styles/common.module.css";

type BlogListProps = {
  data: GetBlogListResponse;
};

export const BlogList: React.FC<BlogListProps> = ({ data }) => {
  return (
    <Masonry
      items={data}
      config={{
        columns: [1, 2, 3],
        gap: [24, 12, 6],
        media: [640, 768, 1024],
      }}
      render={(blog) => (
        <Link href={`/blogs/${blog.slug}`} key={blog.id}>
          <Card
            key={blog.id}
            className="py-0 overflow-hidden relative border border-border hover:border-primary transition-all"
          >
            {blog.latest.coverImage?.url && (
              <LazyImage
                className="absolute! h-full w-full object-cover object-center"
                src={blog.latest.coverImage.url}
                placeholder={blog.latest.coverImage.placeholder}
                alt="blog-cover-image"
              />
            )}
            <div className="backdrop-blur-xs py-4 min-h-72 flex flex-col justify-end bg-linear-to-t from-card via-card/50 via-70% to-transparent">
              <CardHeader className="px-0 relative">
                <div className="px-6 mt-4 text-2xl font-bold">{blog.latest.title}</div>
              </CardHeader>
              <CardContent className="relative">
                {blog.latest.description && (
                  <RTERenderer content={blog.latest.description} className={styles.rteFormStyles} type="form" />
                )}
                <div className="flex justify-between mt-3">
                  <div
                    className="border rounded-full px-2"
                    style={{
                      color: blog.latest.category?.metadata?.color ?? "",
                      borderColor: blog.latest.category?.metadata?.color ?? "",
                    }}
                  >
                    {blog.latest.category?.name}
                  </div>

                  <div className="flex space-x-2">
                    {blog.latest.tags?.map((tag) => (
                      <div
                        key={tag.id}
                        className="border rounded-xl px-2"
                        style={{
                          color: tag.metadata?.color ?? "",
                          borderColor: tag.metadata?.color ?? "",
                        }}
                      >
                        # {tag.name}
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
            </div>
          </Card>
        </Link>
      )}
    />
  );
};
